<template>
  <SPAToast class="ReportToastNotification" v-model="infoToastObj[1]" variant="info" :delay="5000" :animation="false">
    <template #title> Your file is on the way... </template>
    <template #description>We’re working to get your file ready to download. Please check back later!</template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="infoToastObj[2]" variant="info" :delay="5000" :animation="false">
    <template #title> Your file is on the way... </template>
    <template #description>We’re working to get your file ready to download. Please check back later!</template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="infoToastObj[3]" variant="info" :delay="5000" :animation="false">
    <template #title> Your file is on the way... </template>
    <template #description>We’re working to get your file ready to download. Please check back later!</template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="infoToastObj[4]" variant="info" :delay="5000" :animation="false">
    <template #title> Your file is on the way... </template>
    <template #description>We’re working to get your file ready to download. Please check back later!</template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="infoToastObj[5]" variant="info" :delay="5000" :animation="false">
    <template #title> Your file is on the way... </template>
    <template #description>We’re working to get your file ready to download. Please check back later!</template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="successToastObj[1].isOpen" variant="success" :delay="5000" :animation="false">
    <template #title> File is ready to download! </template>
    <template #description>
      <span @click.stop="redirect(successToastObj[1].reportType)">
        <span class="bold">{{ successToastObj[1].fileName }}</span> is available to download for up to <span class="bold days">3 days</span> at {{ successToastObj[1].destination }}.
      </span>
    </template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="successToastObj[2].isOpen" variant="success" :delay="5000" :animation="false">
    <template #title> File is ready to download! </template>
    <template #description>
      <span @click.stop="redirect(successToastObj[2].reportType)">
        <span class="bold">{{ successToastObj[2].fileName }}</span> is available to download for up to <span class="bold days">3 days</span> at {{ successToastObj[2].destination }}.
      </span>
    </template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="successToastObj[3].isOpen" variant="success" :delay="5000" :animation="false">
    <template #title> File is ready to download! </template>
    <template #description>
      <span @click.stop="redirect(successToastObj[3].reportType)">
        <span class="bold">{{ successToastObj[3].fileName }}</span> is available to download for up to <span class="bold days">3 days</span> at {{ successToastObj[3].destination }}.
      </span>
    </template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="successToastObj[4].isOpen" variant="success" :delay="5000" :animation="false">
    <template #title> File is ready to download! </template>
    <template #description>
      <span @click.stop="redirect(successToastObj[4].reportType)">
        <span class="bold">{{ successToastObj[4].fileName }}</span> is available to download for up to <span class="bold days">3 days</span> at {{ successToastObj[4].destination }}.
      </span>
    </template>
  </SPAToast>
  <SPAToast class="ReportToastNotification" v-model="successToastObj[5].isOpen" variant="success" :delay="5000" :animation="false">
    <template #title> File is ready to download! </template>
    <template #description>
      <span @click.stop="redirect(successToastObj[5].reportType)">
        <span class="bold">{{ successToastObj[5].fileName }}</span> is available to download for up to <span class="bold days">3 days</span> at {{ successToastObj[5].destination }}.
      </span>
    </template>
  </SPAToast>
</template>
<style lang="scss">
// Because of its appendToBody nature, it cannot be scoped.
.ReportToastNotification {
  cursor: pointer;
  span.bold {
    font-weight: 500;
  }
  span.days {
    color: $green-300;
  }
}
</style>
<script>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import SPAToast from '../../components/SPAToast.vue';
import { ReportTypesEnum } from '../../enums/reportTypes';
import { useAttendanceReportStore } from '../../stores/attendanceReport';
import { useMyAttendanceStore } from '../../stores/myAttendance';
import { useReportStore } from '../../stores/report';
import { useBreakMonitoringReportStore } from '@/stores/breakMonitoringReport';
export default {
  name: 'ReportToastNotification',
  components: { SPAToast },
  setup() {
    const useMyAttendance = useMyAttendanceStore();
    const { isAttendanceLogsActive } = storeToRefs(useMyAttendance);
    const useAttendanceReport = useAttendanceReportStore();
    const { isSummaryReportActive } = storeToRefs(useAttendanceReport);
    const breakMonitoringReportStore = useBreakMonitoringReportStore();
    const { isBreakLogsActive } = storeToRefs(breakMonitoringReportStore);
    const useReport = useReportStore();
    const { infoToastObj, successToastObj } = storeToRefs(useReport);
    const router = useRouter();
    const redirect = (reportType) => {
      switch (reportType) {
        case ReportTypesEnum.myAttendance:
          isAttendanceLogsActive.value = true;
          router.push('/my-attendance').then(() => {
            isAttendanceLogsActive.value = false;
          });
          break;
        case ReportTypesEnum.attendanceReport:
          isSummaryReportActive.value = true;
          router.push('/attendance-report').then(() => {
            isSummaryReportActive.value = false;
          });
          break;
        case ReportTypesEnum.projectTagging:
          router.push('/project-tagging-maintenance/reports/exportlogs');
          break;
        case ReportTypesEnum.breakMonitoringReport:
          isBreakLogsActive.value = true;
          router.push('/break-monitoring-report').then(() => {
            isBreakLogsActive.value = false;
          });
          break;
        default:
          break;
      }
    };
    return { infoToastObj, successToastObj, redirect };
  },
};
</script>
